import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import TopNavBar from '../usercomponents/TopNavBar';
import Footer from '../usercomponents/Footer';
import SideBar from '../usercomponents/SideBar';
const apiUrl = process.env.REACT_APP_API_URL;
function Fees() {
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const fetchFees = async () => {
      const sessionData = JSON.parse(sessionStorage.getItem('studentSession'));
      if (!sessionData || !sessionData.token) {
        setError('Please login to view fees.');
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(`${apiUrl}/api/student/fees`, {
          headers: { Authorization: `Bearer ${sessionData.token}` },
          params: { ts: Date.now() }
        });
        if (response.data.success) {
          setEnrolledCourses(response.data.courses);
        } else {
          setError(response.data.message || 'Failed to fetch fees.');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Error fetching fees.');
      } finally {
        setLoading(false);
      }
    };
    fetchFees();
  }, []);
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    }).format(amount);
  };
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };
  if (loading) return <div className="text-center my-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>;
  if (error) return <div className="alert alert-danger text-center mx-auto my-5" style={{ maxWidth: '600px' }}>{error}</div>;
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body px-3">
          <div className="breadcrumb mb-4">
            <ul className="d-flex align-items-center gap-2 list-unstyled">
              <li>
                <Link to="/student-dashboard" className="text-gray-200 text-15 hover-text-main-600 text-decoration-none">
                  Home
                </Link>
              </li>
              <li>
                <span className="text-gray-500 d-flex align-items-center">
                  <i className="ph ph-caret-right" />
                </span>
              </li>
              <li>
                <span className="text-main-600 text-15">Fees</span>
              </li>
            </ul>
          </div>
          <div className="card shadow-sm border-0">
            <div className="card-body p-4">
              <h4 className="mb-4 text-main-600 fw-bold">Fees Overview</h4>
              {enrolledCourses.length === 0 ? (
                <div className="alert alert-info text-center">No enrolled courses found.</div>
              ) : (
                enrolledCourses.map((course) => (
                  <div key={course.courseid} className="card mb-4 shadow-sm border-0 animate__animated animate__fadeIn">
                    <div className="card-body p-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0 fw-bold text-gray-800">{course.coursename}</h5>
                        <span className="badge bg-primary text-white px-3 py-2">Course ID: {course.courseid}</span>
                      </div>
                      <div className="row g-3 mb-4">
                        <div className="col-md-3">
                          <div className="p-3 bg-light rounded-3 text-center">
                            <p className="mb-1 text-gray-600 fw-medium">Original Fee</p>
                            <h6 className="mb-0 text-main-600 fw-bold">{formatCurrency(course.originalFee)}</h6>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="p-3 bg-light rounded-3 text-center">
                            <p className="mb-1 text-gray-600 fw-medium">Total Discount</p>
                            <h6 className="mb-0 text-success-600 fw-bold">{formatCurrency(course.totalDiscount)}</h6>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="p-3 bg-light rounded-3 text-center">
                            <p className="mb-1 text-gray-600 fw-medium">Fee Paid</p>
                            <h6 className="mb-0 text-success-600 fw-bold">{formatCurrency(course.feePaid)}</h6>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="p-3 bg-light rounded-3 text-center">
                            <p className="mb-1 text-gray-600 fw-medium">Balance</p>
                            <h6 className="mb-0 text-danger-600 fw-bold">{formatCurrency(course.balance)}</h6>
                          </div>
                        </div>
                      </div>
                      <h6 className="mb-3 fw-bold text-gray-800">Payment History</h6>
                      {course.payments.length === 0 ? (
                        <p className="text-gray-500">No payments made yet.</p>
                      ) : (
                        <div className="table-responsive">
                          <table className="table table-hover table-bordered">
                            <thead className="bg-main-50">
                              <tr>
                                <th>Date</th>
                                <th>Transaction ID</th>
                                <th>Amount</th>
                                <th>Mode</th>
                                <th>Remark</th>
                              </tr>
                            </thead>
                            <tbody>
                              {course.payments.map((payment) => (
                                <tr key={payment.id} className="transition-all duration-200 hover-bg-main-100">
                                  <td>{formatDate(payment.datepaid)}</td>
                                  <td>{payment.transactionid}</td>
                                  <td>{formatCurrency(payment.amountpaid)}</td>
                                  <td>{payment.modeofpayment}</td>
                                  <td>{payment.remark || 'N/A'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                      <h6 className="mb-3 fw-bold text-gray-800 mt-4">Discount History</h6>
                      {course.discounts.length === 0 ? (
                        <p className="text-gray-500">No discounts applied yet.</p>
                      ) : (
                        <div className="table-responsive">
                          <table className="table table-hover table-bordered">
                            <thead className="bg-main-50">
                              <tr>
                                <th>Date Applied</th>
                                <th>Original Fee</th>
                                <th>Discount Amount</th>
                                <th>New Fee</th>
                                <th>Remark</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {course.discounts.map((discount) => (
                                <tr key={discount.id} className="transition-all duration-200 hover-bg-main-100">
                                  <td>{formatDate(discount.date_applied)}</td>
                                  <td>{formatCurrency(discount.original_fee)}</td>
                                  <td>{formatCurrency(discount.discount_amount)}</td>
                                  <td>{formatCurrency(discount.new_fee)}</td>
                                  <td>{discount.remark || 'N/A'}</td>
                                  <td>{discount.status === 1 ? 'Approved' : 'Pending'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default Fees;